import {React, useEffect, useState} from 'react'
import {Grid, Select, TextField,MenuItem, InputLabel} from '@mui/material'
import {businessUnitServices} from 'src/services/reservation/businessUnit/businessUnit.service'
import {itemServices} from 'src/services/reservation/item/item.service'
import { useTranslate } from 'react-admin'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useNotify } from 'react-admin'
import { LoadingButton } from '@mui/lab'
import Button from '@mui/material/Button'

export const PaymentSupplierDialog = ({businessUnitId, items, setPaymentSupplierDialog}) => {
    const [currencies, setCurrencies] = useState([])
    const translate = useTranslate()
    const [form, setForm] = useState({})
    const [amountToShow, setAmountToShow] = useState(false)
    const [importe, setImporte] = useState('')
    const [validationError, setValidationError] = useState(false)
    const [supplier, setSupplier] = useState('')
    const notify = useNotify()
    const [loaddingButton, setLoaddingButton] = useState(false)
    const getCurrency = async () =>{
       await businessUnitServices.currencies_by_business_unit(businessUnitId).then(res=>{
            setCurrencies(res)
        })
    }

    /* const getSuppliers = () =>{
        for(let item of items){
            if(!suppliers.some((el)=>el.id === item?.supplier_relation?.id)){
                suppliers.push({id:item?.supplier_relation?.id, name:item?.supplier_relation?.name, code:item?.supplier_relation?.code})
                setSuppliers(suppliers)
            }
            
        }
    } */

    const getName = (list) =>{
      if (list && Array.isArray(list) && list.length !== 0) {
        let listAirports = list.map((data) => `${data.boardPoint}/${data.offPoint} - `)
        let concant = listAirports.join('')
        let delete_last_characters = concant?.slice(0, -2)
        return delete_last_characters
      }
    }

    const calculateName = (item) =>{
      if(item?.product?.ref_table_detail === "train_detail_passes"){
        return item?.passes?.[0]?.company_name
      }
      if(item?.product?.product_type_relation?.short_name === 'AUTO'){
        return item?.provider
      }
      if(item?.product?.ref_table_detail === 'train_detail_segment'){
        return `${item?.segments?.[0]?.origin_name}/${item?.segments?.[0]?.arrival_name}`
      }
      if(item?.product?.product_type_relation?.short_name === 'AEREOS'){
        return getName(item?.segments?.[0]?.itineraryGroup)
      }
      if(item?.product?.product_type_relation?.short_name === "ASISTENCIA" || item?.product?.product_type_relation?.short_name === "TRENES"){
        return `${item.destination} / ${item.name}`
      }
      if(item?.product?.ref_table_detail === "transfer_detail"){
        return item?.pickup_origin
      }
      if(item?.product?.product_type_relation?.short_name === "HOTEL" || 
        item?.product?.product_type_relation?.ref_table_detail === 'other_detail'
      ){
        return item.name
      }
      
      
      
    
    }

    const generate_order = async () =>{
      setLoaddingButton(true)
      await itemServices.generate_order(form).then((res)=>{
        setPaymentSupplierDialog(false)
        notify(translate('ra.message.generate_provider_order'), {
          type: 'success',
        })
      }).finally(()=>{
        setLoaddingButton(false)
      })
    }

    const validateForm = () =>{
      if(form.currency && form.amount && form.date && form.hash_item) {
        return true
      }
      setValidationError(true)
      return false
    }

    useEffect(()=>{
        getCurrency()
    },[])

    const formatNumber = (num) => {
        return new Intl.NumberFormat('es-AR', {
          style: 'decimal',
          maximumFractionDigits: 2,
        }).format(num);
      };

    const handleChange = (e) => {
        const rawValue = e.target.value;
    
        // Remove any non-numeric characters except for the comma (decimal separator) and period (thousands separator)
        const sanitizedValue = rawValue.replace(/[^\d,\.]/g, '');
    
        // If the user enters a valid number or decimal value, format it
        let formattedValue = sanitizedValue;
        
        // Replace commas with periods for handling decimal separator
        formattedValue = formattedValue.replace(',', '.');
        
        // Parse to number and reformat with Argentinean convention
        
        if (!isNaN(formattedValue)) {
            setImporte(formattedValue)
            setAmountToShow(formattedValue)
            setForm({...form, amount:Number(formattedValue)})
        } else {
            setForm({...form, amount:''})
        }
      };

  return (
    <Grid container spacing={3} style={{marginTop:'5px'}}>
        <Grid item sm={12}>
            <InputLabel id="currency">{translate('ra.entity.currency')}</InputLabel>
            <Select
            value={form.currency || ''}
            labelId="currency"
            error = {!form.currency && validationError}
            onChange={(cur)=>{setForm({...form, currency:cur.target.value})}}
            fullWidth
            size='small'
            >
                {currencies.map((currency)=>(
                    <MenuItem key={currency.id} value={currency.short_name}>{currency.long_name}</MenuItem>
                ))}
            </Select>
        </Grid>
        <Grid item sm={12}>
            <InputLabel id="item">Item</InputLabel>
            <Select
            value={form.hash_item|| ''}
            labelId="item"
            error = {!form.hash_item && validationError}
            onChange={(item)=>{setForm({...form, hash_item:item.target.value})}}
            fullWidth
            size='small'
            >
                {items.map((item)=>(
                    <MenuItem onClick={()=>setSupplier(item?.supplier_relation?.billing_code )} key={item.id} value={item.hash_}>{calculateName(item)}</MenuItem>
                ))}
            </Select>
        </Grid>
        <Grid item sm={12}>
        <TextField
            value={supplier|| ''}
            disabled
            label={translate('ra.field.supplier')}
            size='small'
            />
        </Grid>
        <Grid item sm={12}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
            <DatePicker 
                renderInput={(params)=>{
                            return (<TextField
                                {...params}
                                error = {!form.date && validationError}
                                size='small'
                                label={translate('ra.field.date')}
                            />) }} 
                onChange = {(date)=>{setForm({...form, date})}}
                value={form.date || null}
                minDate={new Date()}
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, -50],
                      },
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'viewport',
                      },
                    },
                  ],
                }}
            />
        </LocalizationProvider>
            </Grid>
            <Grid item sm={12}>
            <TextField
                value={amountToShow || ''}
                error={!form.amount && validationError}
                onFocus={()=>{setAmountToShow(importe)}}
                onBlur={()=>{setAmountToShow(formatNumber(importe))}}
                onChange={handleChange}
                label={translate('ra.field.amount')}
                size='small'
            />
            </Grid>
            <Grid item sm={12}>
            <TextField
                value={form.observations || ''}
                onChange={(obs) => {setForm({...form, observations:obs.target.value})}}
                label={translate('ra.title.observations')}
                size='small'
                fullWidth
            />
        </Grid>
        <Grid item sm={12} style={{ display: 'flex', flexDirection:'row',alignItems: 'center', justifyContent: 'space-between' }}>
          <Button
            variant='outlined'
            onClick={() => {
                setPaymentSupplierDialog(false)
            }}
            autoFocus
          >
            {translate('ra.action.cancel')}
          </Button>
          { 
            <LoadingButton
              variant='contained'
              onClick={() => {
                setForm({...form, amount:importe})
                if(validateForm()){
                  generate_order()
                }
                
              }}
              /* loading={loadingModalButton}
              disabled={loadingMessage} */
              loading = {loaddingButton}
            >
              {translate('ra.action.generate')}
            </LoadingButton>
          }
        </Grid>
    </Grid>
  )
}
